import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { MinorRegistration } from '@loyalty-v3/libs';
import { Child } from '@models/legal-guardian/child';
import { Store } from '@ngrx/store';
import { childrenInfos } from '@stores/children-infos/children-infos.selector';
import { partnerId } from '@stores/partner/partner.selectors';
import { MinorRegistrationWebservice } from '@webservices/minor-registration/minor-registration.webservice';
import { filter, map, switchMap } from 'rxjs';

export const childResolver: ResolveFn<Child | null> = (route: ActivatedRouteSnapshot) => {
  return inject(Store)
    .select(childrenInfos)
    .pipe(
      filter((v): v is Child[] => v.length > 0),
      map((children) => children.filter(({ customerId }) => customerId === route.params.childId)[0] ?? null)
    );
};

export const minorRegistrationResolver: ResolveFn<MinorRegistration> = (route: ActivatedRouteSnapshot) => {
  const minorRegistrationWebservice = inject(MinorRegistrationWebservice);

  const childCustomerId = route.params.childId;

  return inject(Store)
    .select(partnerId)
    .pipe(switchMap((id) => minorRegistrationWebservice.getMinorRegistration(id ?? '', childCustomerId ?? '')));
};

export const minorRegistrationPlanResolver: ResolveFn<MinorRegistration> = (route: ActivatedRouteSnapshot) => {
  const minorRegistrationWebservice = inject(MinorRegistrationWebservice);

  const childCustomerId = route.params.childId;

  return inject(Store)
    .select(partnerId)
    .pipe(
      switchMap((id) => minorRegistrationWebservice.getMinorRegistrationPlan(id ?? '', childCustomerId ?? '')),
      map((minorRegistration) => [minorRegistration])
    );
};
